<template>
  <v-dialog fullscreen scrollable
    v-model="config.status.active">
    <v-card class="grey lighten-4">
      <v-card-title class="transparency pb-0">
        <MitsuisumitomoHeader v-if="getBookCompany === 'mitsuisumitomo'" />
        <RakutenHeader v-else-if="getBookCompany === 'rakuten'" />
        <DcCardHeader v-else-if="getBookCompany === 'dc'" />
        <LifeCardHeader v-else-if="getBookCompany === 'life'" />
        <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'" />
      </v-card-title>
      <v-card-text class="transparency">
        <Mitsuisumitomo v-if="!isLoading && getBookCompany === 'mitsuisumitomo'" :items="getItems" />
        <Rakuten v-else-if="!isLoading && getBookCompany === 'rakuten'" :items="getItems" />
        <DcCard v-else-if="!isLoading && getBookCompany === 'dc'" :items="getItems" />
        <LifeCard v-else-if="!isLoading && getBookCompany === 'life'" :items="getItems" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-menu right offset-y>
          <template v-slot:activator="{ on }">
            <v-btn fab text small
              v-on="on"
              class="mr-2"
              color="secondary"
              :disabled="isLoading"><v-icon small>fa-ellipsis-v</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="downloadFile">
              <v-list-item-avatar>
                <v-icon small>fal fa-download</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>ダウンロード</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <span class="body-2">{{ printItemName }}</span>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Mitsuisumitomo from './components/mitsuisumitomo'
import MitsuisumitomoHeader from './components/mitsuisumitomo/header'
import Rakuten from './components/rakuten'
import RakutenHeader from './components/rakuten/header'
import DcCard from './components/dc'
import DcCardHeader from './components/dc/header'
import LifeCard from './components/life'
import LifeCardHeader from './components/life/header'

const DEF = {
  FORM: {
    book: {
      sheet: 1
    },
    max: 200,
  }
}
export default {
  name: 'authorBbookPreview',
  props: [],
  components: {
    Mitsuisumitomo,
    MitsuisumitomoHeader,
    Rakuten,
    RakutenHeader,
    DcCard,
    DcCardHeader,
    LifeCard,
    LifeCardHeader
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      },
      form: {
        max: DEF.FORM.max,
        book: {
          sheet: DEF.FORM.book.sheet
        }
      },
      store: {
        type: '',
        company: '',
        item: {},
        items: []
      }
    }
  },
  methods: {
    open: function (req) {
      const { type, company, item } = req || {}
      if (type && item) {
        this.$set(this.store, 'type', type)
        this.$set(this.store, 'company', company)
        this.$set(this.store, 'item', item)
        this.setConfig(JSON.parse(JSON.stringify(DEF.FORM)))
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.submit({ type: 'preview' })
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    downloadFile: function () {
      this.submit({ type: 'download' })
    },
    setConfig: function (req) {
      this.$set(this, 'form', Object.assign({}, this.form, req))
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { id } = this.store.item || {}
      const urls = {
        preview: `${this.$url.api}/bbook/read/book/${id}`,
        download: `${this.$url.api}box/download/${id}`
      }
      const fds = {
        preview: { type: this.store.type, company: this.store.company, cfg: this.form },
        download: {}
      }
      if (type && urls[type] && fds[type]) {
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, submitType) {
      const type = submitType || ''
      if (type === 'preview') {
        this.$set(this.store, 'items', req.entries)
        this.$set(this.config.status, 'loading', false)
      } else if (type === 'download') {
        window.location.href = req
        this.$set(this.config.status, 'loading', false)
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    printItemName () {
      return this.store.item && this.store.item.name
    },
    getBookType () {
      return this.store.type
    },
    getBookCompany () {
      return this.store.company
    },
    getItems () {
      return this.store.items
    }
  }
}
</script>